export const FR_PHONE_REGEX =
  /^(?:\+33(?:\s|\u00A0)?[1-9](?:[\s.\-\u00A0]?\d{2}){4}|0[1-9](?:[\s.\-\u00A0]?\d{2}){4})$/u;

export const FR_SIREN_REGEX = /^\d{9}$/;

// Lettres (unicode), espaces, tirets, apostrophes droites et typographiques
export const NAME_REGEX = /^[\p{L}\s\-’,']+$/u;
